NtechApp.Loader = function(width, height, position, $target, additionalCss) {
    this._sizesResolver = new NtechApp.SizesResolver();

    this._width = (typeof width == "undefined") ? 42 : parseFloat(width);
    this._height = (typeof height == "undefined") ? 42 : parseFloat(height);
    this._position = (typeof position == "undefined") ? "fixed" : position;
    this._$target = (typeof $target == "undefined") ? $("body") : $target;
    this._css = additionalCss || {};

    this._$loader = null;
    this._rmTimeout = null;

    this._create();
};

NtechApp.proto(NtechApp.Loader, {
    getView: function() {
        return this._$loader;
    },

    white: function() {
        this._$loader.find(".cssload-loader").addClass("whiteLoader");
        return this;
    },

    updateCss: function(css) {
        this._$loader.css(css);
    },

    _create: function() {
        var html = '<div class="ntechapp-loader"><div class="cssload-loader">';
        html += '<div class="cssload-ballcolor cssload-ball_1"></div>';
        html += '<div class="cssload-ballcolor cssload-ball_2"></div>';
        html += '<div class="cssload-ballcolor cssload-ball_3"></div>';
        html += '<div class="cssload-ballcolor cssload-ball_4"></div>';
        html += '</div></div>';

        this._$loader = $(html);
        this._applyCss(this._$loader);
        this._applyChildCss(this._$loader);
        this._$loader.appendTo(this._$target);

        // Apply opacity: 0 per item right after append
        this._sizesResolver.getComputedCss(this._$loader).opacity;
    },

    on: function() {
        // if(this._$loader != null) {
        //     clearTimeout(this._rmTimeout);
        //     return;
        // }
        clearTimeout(this._rmTimeout);
        this._$loader.css("display", "block");

        // var html = '<div class="ntechapp-loader"><div class="cssload-loader">';
        // html += '<div class="cssload-ballcolor cssload-ball_1"></div>';
        // html += '<div class="cssload-ballcolor cssload-ball_2"></div>';
        // html += '<div class="cssload-ballcolor cssload-ball_3"></div>';
        // html += '<div class="cssload-ballcolor cssload-ball_4"></div>';
        // html += '</div></div>';

        // this._$loader = $(html);
        // this._applyCss(this._$loader);
        // this._applyChildCss(this._$loader);
        // this._$loader.appendTo(this._$target);

        // Apply opacity: 0 per item right after append
        this._sizesResolver.getComputedCss(this._$loader).opacity;
        this._$loader.addClass("visible");

        return this;
    },

    _applyCss: function($container) {
        $container.css({
            position: this._position
        });

        var $loader = $container.find(".cssload-loader");
        $loader.css({
            width: this._width + "px",
            height: this._height + "px",
            marginLeft: "-" + (this._width / 2) + "px",
            marginTop: "-" + (this._height / 2) + "px"
        });

        for(var prop in this._css)
            $container.css(prop, this._css[prop]);
    },

    _applyChildCss: function($loader) {
        var circlesPxPadding = 0;
        var halfWidth = this._width / 2;
        var halfHeight = this._height / 2;

        $loader.find(".cssload-ballcolor").css({
            width: (halfWidth - circlesPxPadding) + "px",
            height: (halfHeight - circlesPxPadding) + "px"
        });

        $loader.find(".cssload-ball_2").css({
            left: halfWidth + circlesPxPadding + "px",
            top: "0px"
        });
        $loader.find(".cssload-ball_3").css({
            left: "0px",
            top: halfHeight + circlesPxPadding + "px"
        });
        $loader.find(".cssload-ball_4").css({
            left: halfWidth + circlesPxPadding + "px",
            top: halfHeight + circlesPxPadding + "px"
        });
    },

    off: function(timeout) {
        var me = this;
        var timeout = timeout || 500;
        //if(this._$loader == null) return;

        this._$loader.removeClass("visible");
        // this._rmTimeout = setTimeout(function() {
        //     if(me._$loader == null) return;

        //     me._$loader.remove();
        //     me._$loader = null;
        // }, 500);
        this._rmTimeout = setTimeout(function() {
            me._$loader.css("display", "none");
        }, timeout);

        return this;
    },

    destroy: function() {
        this._$loader.remove();
    }
});